import { Injectable, isDevMode } from '@angular/core';

/* eslint-disable no-console */
@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  log(...args: unknown[]): void {
    if (isDevMode()) {
      console.log(...args);
    }
  }

  info(...args: unknown[]): void {
    if (isDevMode()) {
      console.info(...args);
    }
  }

  warn(...args: unknown[]): void {
    if (isDevMode()) {
      console.warn(...args);
    }
  }

  error(...args: unknown[]): void {
    if (isDevMode()) {
      console.error(...args);
    }
  }

  debug(...args: unknown[]): void {
    if (isDevMode()) {
      console.debug(...args);
    }
  }
}
